import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableSortableHeaderColumn,
} from '@unite-us/app-components';
import { tableWidth } from 'common/helpers/Tables';
import EligibilityAssessmentTableRow from './EligibilityAssessmentTableRow';

const EligibilityAssessmentsTable = ({
  assessments,
  contactId,
  sortBy,
  sortDirection,
  onSortChange,
  emptyMessage,
}) => {
  const setSort = ({ sortBy: sort, sortDirection: direction }) => {
    onSortChange(sort, direction);
  };

  if (isEmpty(assessments)) {
    return (
      <div className="flex justify-center p-6">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <Table noBorder id="eligibility-assessments-table">
      <TableHeader>
        <TableRow>
          <TableHeaderColumn style={{ width: tableWidth('medium') }}>
            Form
          </TableHeaderColumn>
          <TableHeaderColumn style={{ width: tableWidth('medium') }}>
            Submitter
          </TableHeaderColumn>
          <TableHeaderColumn style={{ width: tableWidth('small') }}>
            Status
          </TableHeaderColumn>
          <TableHeaderColumn style={{ width: tableWidth('medium') }}>
            Organization
          </TableHeaderColumn>
          <TableSortableHeaderColumn
            style={{ width: tableWidth('small') }}
            colName={'updated_at'}
            sortBy={sortBy}
            sortDirection={sortDirection}
            setSort={setSort}
          >
            Last Updated
          </TableSortableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {assessments.map((assessment) => (
          <EligibilityAssessmentTableRow
            key={assessment.id}
            assessment={assessment}
            contactId={contactId}
          />
        ))}
      </TableBody>
    </Table>
  );
};

EligibilityAssessmentsTable.propTypes = {
  assessments: PropTypes.array.isRequired,
  contactId: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  emptyMessage: PropTypes.string.isRequired,
};

export default EligibilityAssessmentsTable;
